import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  getSistemas,
  postSistema,
  patchSistema,
  deleteSistema,
} from 'api/recaudacion/sistemas';

// eslint-disable-next-line react/prop-types
const Sistemas = ({ permission }) => (
  <PlainCRUD
    title="Sistema"
    permission={permission}
    get={getSistemas}
    post={postSistema}
    patch={patchSistema}
    delete={deleteSistema}
    fields={[
      defaultFields.descripcion,
    ]}
  />
);

export default Sistemas;
